import { render, staticRenderFns } from "./MethodStripeCheckout.vue?vue&type=template&id=3653f04e&"
import script from "./MethodStripeCheckout.vue?vue&type=script&lang=js&"
export * from "./MethodStripeCheckout.vue?vue&type=script&lang=js&"
import style0 from "./MethodStripeCheckout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports